import { useDebounceFn } from '@vueuse/core'

import type { WsBookingEvent } from '@brighterly/lib-core-types/ws/interfaces'

import { WsEvent } from '@ts-ws/enums'

import { useCustomerStore } from '@stores/me/customer'
import { useBookingStore } from '@stores/booking'
import { useDisciplineStore } from '@stores/discipline'

import { onDisciplineReady } from '@hooks/discipline/on-discipline-ready.hook'
import { useKidRoutes } from '@composables/routes/kid-route.hook'

export const useListenEventBooking = (channel: any): void => {
  const customerStore = useCustomerStore()
  const bookingStore = useBookingStore()
  const disciplineStore = useDisciplineStore()

  const setRefreshData = async (): Promise<void> => {
    if (isRouteHome.value) {
      if (disciplineStore.isActivation)
        return

      await customerStore.refreshNow()
      await bookingStore.refreshCurrentNow({ background: true })
    }
  }

  const setRefreshAllLessons = async (): Promise<void> => {
    if (isRouteLessons.value) {
      await bookingStore.refreshNow({ background: true })
      await bookingStore.refreshFinishedNow({ background: true })
    }
  }

  const timeout = 6000
  const setDebouncedRefresh = useDebounceFn(setRefreshData, timeout)
  const setDebouncedRefreshAllLessons = useDebounceFn(setRefreshAllLessons, timeout)

  const { isRouteHome, isRouteLessons } = useKidRoutes()

  onDisciplineReady(() => {
    if (isRouteHome.value || isRouteLessons.value) {

      channel.listen(WsEvent.BookingCreated, (): void => {
        setDebouncedRefresh()
        setDebouncedRefreshAllLessons()
      })

      channel.listen(WsEvent.BookingDeleted, (): void => {
        setDebouncedRefresh()
        setDebouncedRefreshAllLessons()
      })

      channel.listen(WsEvent.BookingUpdated, async (event: WsBookingEvent): Promise<void> => {
        const currentBooking = (event.id === bookingStore.getCurrentBooking?.id)

        if (currentBooking) {
          setDebouncedRefresh()
        }

        setDebouncedRefreshAllLessons()
      })
    }
  })
}
